/** Google Customer Reviews / Merchant Center store widget configuration. */
export const GOOGLE_MERCHANT_ID =
  Number(process.env.REACT_APP_GOOGLE_MERCHANT_ID) || 5543412693;

export const GOOGLE_MERCHANT_REGION =
  process.env.REACT_APP_GOOGLE_MERCHANT_REGION || 'KE';

export const GOOGLE_GCR_LANGUAGE =
  process.env.REACT_APP_GOOGLE_GCR_LANGUAGE || 'en';

export const GOOGLE_GCR_OPT_IN_STYLE =
  process.env.REACT_APP_GOOGLE_GCR_OPT_IN_STYLE || 'CENTER_DIALOG';

export const DEFAULT_GOOGLE_CUSTOMER_REVIEWS = {
  badgeEnabled: false,
  inquiryOptInEnabled: false,
  backendSurveyEnabled: false,
};

export function normalizeGoogleCustomerReviews(raw) {
  const g = raw && typeof raw === 'object' ? raw : {};
  return {
    badgeEnabled: g.badgeEnabled === true,
    inquiryOptInEnabled: g.inquiryOptInEnabled === true,
    backendSurveyEnabled: g.backendSurveyEnabled === true,
  };
}

export function isGoogleCustomerReviewsEnabled() {
  return Number.isFinite(GOOGLE_MERCHANT_ID) && GOOGLE_MERCHANT_ID > 0;
}

export function isGoogleReviewBadgeActive(gcrSettings) {
  return isGoogleCustomerReviewsEnabled() && normalizeGoogleCustomerReviews(gcrSettings).badgeEnabled;
}

export function isInquiryOptInActive(gcrSettings) {
  return (
    isGoogleCustomerReviewsEnabled() &&
    normalizeGoogleCustomerReviews(gcrSettings).inquiryOptInEnabled
  );
}

export function isBackendSurveyActive(gcrSettings) {
  return (
    isGoogleCustomerReviewsEnabled() &&
    normalizeGoogleCustomerReviews(gcrSettings).backendSurveyEnabled
  );
}
